import React from "react";
import style from "./index.module.scss";

export function FormRow({ children, ...props }) {
  return (
    <div className={style["form__container--row"]} {...props}>
      {children}
    </div>
  );
}
export function FormGroupCustom({ children, ...props }) {
  return (
    <div className={style["form__container--custom"]} {...props}>
      {children}
    </div>
  );
}

export function FormRowGroup({ children, ...props }) {
  return (
    <div className={style["form__row--group"]} {...props}>
      {children}
    </div>
  );
}
export function FormRowCheckbox({ children, ...props }) {
  return (
    <div className={style["form__row--checkbox"]} {...props}>
      {children}
    </div>
  );
}

export function FormRowRadio({ children, ...props }) {
  return (
    <div className={style["form__row--radio"]} {...props}>
      {children}
    </div>
  );
}
